import { DocumentPreviewOverlay, DocumentPreviewProvider } from '@europrocurement/l2d-modules';
import React from 'react';
import { Outlet } from 'react-router-dom';

const FactureRoot: React.FunctionComponent = function () {
    return (
        <DocumentPreviewProvider>
            <Outlet />
            <DocumentPreviewOverlay />
        </DocumentPreviewProvider>
    );
};

export default FactureRoot;
